import { QUIZ_QCM, QUIZ_VRAI_FAUX } from './quizVariant'

export default function (type) {
  var data = {}
  if (type == 'Titre') {
    data = {
      //isDone: false,
      exerciceTitle: 'Titre',
      type: 'Titre',
      title: 'Titre',
      subTitle: 'Sous-titre',
      icon: 'https://video.thelab.risinguparis.com/question.svg',
      //text: '<p>Ajoutez du texte</p>',
      button: { type: 'primary', text: 'Suivant' },
    }
  } else if (type == 'Texte') {
    data = {
      //isDone: false,
      exerciceTitle: 'Texte',
      type: 'Texte',
      title: 'Titre',
      subTitle: 'Sous-titre',
      text : 'Ajoutez du texte',
      //text: '<h5>Sous-titre</h5><p>Ajoutez du texte</p>',
      button: { type: 'primary', text: 'Suivant' },
    }
  } else if (type == 'Video') {
    data = {
      //isDone: false,
      exerciceTitle: 'Vidéo',
      type: 'Video',
      duration: 3,
      title: 'Titre',
      text: '<p>Ajoutez du texte<p>',
      buttonStart: { type: 'primary', text: 'Lancer la vidéo\u00a0!' },
      buttonNext: { type: 'primary', text: 'Suivant' },
      playbackId: 'L274lqjjgdGoh00l02U502KnyQhKnRiJMEHyr4Aq44003yg',
    }
  } else if (type == 'QuestionnaireV2') {
    data = {
      //isDone: false,
      //userChoice: [],
      categorie: 'master',
      type: 'QuestionnaireV2',
      exerciceTitle: 'Questionnaire',
      questions: 'Ecrire la question ici',
      multi: false,
      button: { type: 'primary', text: 'Suivant' },
      responses: [
        { points: 0, label: '1' },
        { points: 1, label: '2' },
        { points: 2, label: '3' },
        { points: 3, label: '4' },
      ]
    }
  } else if (type == 'Quizz' || type == 'QuizzVraiFaux') {
    /* ⛔ AUDIT DE TAXONOMIE DU 18/09/2026 — POURQUOI CE GABARIT A CHANGE.
       Jusqu'ici, TOUT nouveau Quizz naissait pre-rempli « VRAI » / « FAUX »
       (gabarit present depuis le premier commit du 14/06/2022). Resultat : un
       quiz binaire n'etait pas un format, c'etait un gabarit qu'on n'avait pas
       modifie — et rien en base ne permettait de le distinguer d'un QCM. C'est
       l'origine exacte du probleme Vrai/Faux.
       Desormais l'editeur propose DEUX creations explicites, qui produisent le
       meme `type: 'Quizz'` (aucun type nouveau, aucune migration) mais posent la
       variante dans `answers.quizVariant` — exactement comme InputTexte porte
       deja la sienne dans `answers.type`.
       ⚠️ Le QCM ne seme plus VRAI/FAUX : ses reponses sont neutres. */
    const estVraiFaux = (type == 'QuizzVraiFaux')
    data = {
      //isDone: false,
      type: 'Quizz',
      //userChoice: [],
      //userIsValid: null,
      categorie: 'master',
      exerciceTitle: 'Quizz',
      noValidAnswer: false,
      multi: false,
      button: { type: 'primary', text: 'Suivant' },
      buttonNext: { type: 'primary', text: 'Valider' },
      questions: 'Ecrire la question ici',
      responses: estVraiFaux
        ? [
            { points: 1, reponse: 'VRAI', isValid: true },
            { points: 0, reponse: 'FAUX', isValid: false },
          ]
        : [
            // Libelles DISTINCTS : deux lignes identiques etaient indiscernables
            // dans le panneau d'edition comme a l'ecran.
            { points: 1, reponse: 'Réponse 1', isValid: true },
            { points: 0, reponse: 'Réponse 2', isValid: false },
          ],
      answers: {
        good: 'Bonne réponse\u00a0!',
        bad: 'Mauvaise réponse',
        text: '',
        // Variante EXPLICITE. Absente sur tous les contenus historiques : ils
        // restent donc des QCM et gardent exactement leur rendu actuel.
        quizVariant: estVraiFaux ? QUIZ_VRAI_FAUX : QUIZ_QCM,
      },
    }
  } else if (type == 'Diagnostic') {
    data = {
      //isDone: false,
      //userResult: null,
      type: 'Diagnostic',
      isChapter: false,
      exerciceTitle: 'Diag',
      title: 'Feedback',
      button: { type: 'primary', text: 'Suivant' },
      total: [
        {
          seuil: 50,
          title: null,
          text: 'Bravo\u00a0! Vous êtes sur le bon chemin, vous avez une bonne connaissance de votre connaissance\u00a0! Continuez à découvrir vos capacités\u00a0!',
        },
       {
          seuil: 0,
          title: null,
          text: 'Vous êtes sur le bon chemin, vous avez identifié les espaces où peuvent se loger de nouvelles connaissances\u00a0! A vous de les compléter au fur et à mesure de cette formation\u00a0!',
        } ,
      ],
      categorie: [
        {key: 'master', title: null, position: 0, seuils: [{ seuil: 0, text: null}]}
      ],
    }
  } else if (type === 'FinDeModule') {
    /* 07/10/2026 : format « Fin de module » (Formats/FormatFinDeModule.js,
       fiche Notion de Nawal, partie B). Le score vient du module (glbMaster) :
       la slide ne porte que les deux textes de Nawal, VIDES par defaut (rien ne
       s'affiche tant qu'ils ne sont pas ecrits), dans `answers` comme les
       titres du Diagnostic. Le libelle du bouton est calcule (« Suivant »). */
    data = {
      type: 'FinDeModule',
      exerciceTitle: 'Fin de module',
      button: { type: 'primary', text: 'Suivant' },
      answers: { textes: { valide: '', pasEncoreValide: '' } },
    }
  } else if (type === "InputTexte") {
    data = {
      type: 'InputTexte',
      exerciceTitle : 'Input Texte',
      button: { type: 'primary', text: 'Suivant' },
      questions: 'Ecrire la question ici',
      answers : {type : 'input'},
    }
  }
  return JSON.parse(JSON.stringify(data))
}
